import React from "react";
import { Helmet } from "react-helmet";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Storage } from "@aws-amplify/storage";
import ErrorBoundary from "./components/ErrorBoundary";
import { Provider } from "react-redux";
import store from "./lib/ReduxStore";

// Amplify.configure({
//   Auth: {
//     mandatorySignIn: true,
//     region: config.cognito.REGION,
//     userPoolId: config.cognito.USER_POOL_ID,
//     identityPoolId: config.cognito.IDENTITY_POOL_ID,
//     userPoolWebClientId: config.cognito.APP_CLIENT_ID
//   },
//   Storage: {
//     region: config.s3.REGION,
//     bucket: config.s3.BUCKET,
//     identityPoolId: config.cognito.IDENTITY_POOL_ID
// },
//   API: {
//     endpoints: [
//       {
//         name: "schedule",
//         endpoint: config.schGateway.URL,
//         region: config.schGateway.REGION
//       },
//       {
//         name: "users",
//         endpoint: config.usersGateway.URL,
//         region: config.usersGateway.REGION
//       },
//       {
//         name: "appointment",
//         endpoint: config.appointGateway.URL,
//         region: config.appointGateway.REGION
//       },
//       {
//         name: "admin",
//         endpoint: config.adminGateway.URL,
//         region: config.adminGateway.REGION
//       },

//       {
//         name: "mcu",
//         endpoint: config.mcuGateway.URL,
//         region: config.mcuGateway.REGION
//       }
//     ]
//   }
// })

export function SetS3Config(bucket, level) {
    Storage.configure({
        bucket: bucket,
        level: level,
        region: "ap-southeast-1",
        identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
    });
}

const root = createRoot(document.getElementById("root"));

root.render(
    // Note: StrictMode removed to prevent double API calls in development
    // React 18 StrictMode intentionally double-invokes effects to detect side effects
    // In production builds, this doesn't happen regardless of StrictMode
    <>
        <Helmet>
            {/* Content Security Policy */}
            {/* <meta http-equiv="Content-Security-Policy" content="script-src 'self'; style-src 'self' 'unsafe-inline'; frame-ancestors 'none'" /> */}
            <meta
                http-equiv="Content-Security-Policy"
                content="frame-src 'self' https://www.youtube.com https://www.youtube-nocookie.com https://checkout.stripe.com https://wb.invc.in; frame-ancestors 'none'"
            />

            {/* Cross-Origin-Opener-Policy */}
            <meta http-equiv="Cross-Origin-Opener-Policy" content="same-origin" />

            {/* Cross-Origin-Resource-Policy */}
            <meta http-equiv="Cross-Origin-Resource-Policy" content="same-origin" />

            {/* Referrer-Policy */}
            <meta name="referrer" content="same-origin" />

            {/* Strict-Transport-Security */}
            <meta http-equiv="Strict-Transport-Security" content="max-age=31536000; includeSubDomains" />

            {/* X-Content-Type-Options */}
            <meta http-equiv="X-Content-Type-Options" content="nosniff" />

            {/* X-DNS-Prefetch-Control */}
            <meta http-equiv="X-DNS-Prefetch-Control" content="off" />

            {/* X-Download-Options */}
            <meta http-equiv="X-Download-Options" content="noopen" />

            {/* X-Frame-Options */}
            <meta http-equiv="X-Frame-Options" content="deny" />

            {/* X-Permitted-Cross-Domain-Policies */}
            <meta http-equiv="X-Permitted-Cross-Domain-Policies" content="none" />

            {/* X-Powered-By */}
            <meta name="powered-by" content="inclinic" />

            {/* X-XSS-Protection (Not recommended, but if you still want to use it) */}
            <meta http-equiv="X-XSS-Protection" content="1; mode=block" />
        </Helmet>

        {/* <FrameBuster/>
      Your application content goes here */}

        <ErrorBoundary>
            <Provider store={store}>
                <App />
            </Provider>
        </ErrorBoundary>
    </>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
